import { useParams } from "react-router";
import { useVbsWorkOrderShowQuery } from "@/services/backend/vbs/work-orders/api/work-order-api";
import { PricingCards } from "@/services/backend/vbs/pricing/components/pricing-cards";
import { isImmutable } from "@/services/backend/documents/lib/document-state";

export function WorkOrderCompletionPricingRoute() {
  const { workOrderId } = useParams();
  const { data } = useVbsWorkOrderShowQuery({ id: workOrderId! });

  return (
    <PricingCards
      pricingId={data!.pricingId}
      disabled={isImmutable(data!)}
      showPostExecutionReduction
    />
  );
}
